import type { ReactNode } from 'react';

import { useEffect } from 'react';

import { useRouter } from 'src/routes/hooks';

import { AdminRoleEnum } from 'src/types/user';

import { useAuthContext } from '../hooks/use-auth-context';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  allowedRoles?: AdminRoleEnum[];
  redirectTo?: string;
};

export function RoleBasedGuard({ children, allowedRoles, redirectTo }: Props) {
  const router = useRouter();
  const { user, authenticated } = useAuthContext();

  useEffect(() => {
    if (!authenticated) {
      return;
    }

    if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
      const defaultRoute = getDefaultRouteForRole(user.role);
      router.replace(redirectTo || defaultRoute);
    }
  }, [authenticated, user?.role, allowedRoles, redirectTo, router]);

  if (!authenticated) {
    return null;
  }

  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    return null;
  }

  return <>{children}</>;
}

// Función para obtener la ruta por defecto según el rol
export function getDefaultRouteForRole(role: AdminRoleEnum): string {
  switch (role) {
    case AdminRoleEnum.Administrator:
      return '/dashboard';
    case AdminRoleEnum.OperationsManager:
    case AdminRoleEnum.Supervisor:
      return '/dashboard/medias'; // Supervisor y Director de operaciones van directo a medios
    case AdminRoleEnum.EditorManager:
      return '/dashboard/orders'; // Jefa de editores va directo a pedidos
    case AdminRoleEnum.Editor:
      return '/dashboard/orders'; // Editores van directo a pedidos
    case AdminRoleEnum.Outreach:
      return '/dashboard/medias'; // Outreach va directo a medios
    case AdminRoleEnum.Accountant:
      return '/dashboard/invoices'; // Contables van directo a facturas
    default:
      return '/dashboard';
  }
}
